import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { forkJoin, Subscription } from 'rxjs';
import { Gruppe } from '../../../gruppen/classes/gruppe';
import { UntypedFormControl } from '@angular/forms';
import { KieneUtils } from '../../../../utils/KieneUtils';
import { MessageService } from '../../../../services/message-service/message.service';
import { StammdatenService } from '../../../stammdaten/stammdaten.service';
import { Haendler } from '../../../stammdaten/haendler/haendler';
import { TierFilterSettings } from '../gruppe-tier-filter-dialog/classes/tier-filter-settings';
import { HttpParams } from '@angular/common/http';

@Component({
    selector: 'kiene-gruppe-tier-viehhaendler-filter',
    templateUrl: './gruppe-tier-viehhaendler-filter.component.html',
    styleUrls: ['./gruppe-tier-viehhaendler-filter.component.scss'],
})
export class GruppeTierViehhaendlerFilterComponent implements OnInit, OnDestroy, OnChanges {
    haendlerGruppeSubscription: Subscription;
    isLoading = true;
    label = 'Lädt...';

    @Input('gruppe') selectedGruppe: Gruppe;
    @Input() gruppeIds: number[] = [];
    @Input('filter') filter: TierFilterSettings;
    @Input('haendler') haendler: Haendler[] = [];
    @Input('hideOnEmptyList') hideOnEmptyList = false;
    @Output('selectedHaendler') selectedHaendler: EventEmitter<Haendler[]> = new EventEmitter<Haendler[]>();
    selectedHaendlerCtrl: UntypedFormControl = new UntypedFormControl(null);
    haendlerFuerGruppe: Haendler[] = [];

    constructor(
        private messageService: MessageService,
        private stammdatenService: StammdatenService,
    ) {}

    ngOnDestroy(): void {
        this.haendlerGruppeSubscription?.unsubscribe();
    }

    ngOnInit(): void {
        this.loadTierHaendlerFuerGruppe();

        this.selectedHaendlerCtrl.setValue(this.haendler);

        // this.selectedHaendlerCtrl.valueChanges.subscribe(data => {
        //     this.selectedHaendler.emit(data);
        // });
    }

    ngOnChanges() {
        if (this.selectedGruppe || (this.gruppeIds || []).length > 0) {
            this.loadTierHaendlerFuerGruppe();
        }
    }

    resetHaendlerCtrl($event: MouseEvent) {
        $event.stopPropagation();
        this.selectedHaendlerCtrl.setValue(undefined);
        this.selectionChanged();
    }

    compareHaendler(a: Haendler, b: Haendler) {
        return a && b && KieneUtils.sameId(a.viehhaendler_id, b.viehhaendler_id);
    }

    selectionChanged() {
        this.selectedHaendler.emit(this.selectedHaendlerCtrl.value);
    }

    public update() {
        this.loadTierHaendlerFuerGruppe();
    }

    public setSelectedHaendler(haendler: Haendler[]) {
        this.selectedHaendlerCtrl.setValue(haendler, { emitEvent: false });
    }

    private loadTierHaendlerFuerGruppe() {
        this.isLoading = true;
        const targetGroupIds =
            (this.gruppeIds || []).map(id => Number(id)).filter(id => id > 0).length > 0
                ? (this.gruppeIds || []).map(id => Number(id)).filter(id => id > 0)
                : this.selectedGruppe?.gruppe_id
                  ? [Number(this.selectedGruppe.gruppe_id)]
                  : [];
        if (targetGroupIds.length > 0) {
            let params = new HttpParams();
            if (this.filter && this.filter.einstalldatum && this.filter.einstalldatum.length > 0) {
                for (const e of this.filter.einstalldatum) {
                    params = params.append('einstalldatum[]', e.einstalldatum.toString());
                }
            }
            this.haendlerGruppeSubscription?.unsubscribe();
            const requests = targetGroupIds.map(gruppeId => this.stammdatenService.ladeViehhaendler(gruppeId, params));
            this.haendlerGruppeSubscription = forkJoin(requests).subscribe({
                    next: result => {
                        this.selectedHaendlerCtrl.enable();
                        this.isLoading = false;
                        const byId = new Map<number, Haendler>();
                        for (const res of result || []) {
                            for (const item of res?.records || []) {
                                const key = Number(item?.viehhaendler_id || 0);
                                if (key <= 0 || byId.has(key)) {
                                    continue;
                                }
                                byId.set(key, item);
                            }
                        }
                        this.haendlerFuerGruppe = Array.from(byId.values());
                        this.haendlerFuerGruppe.sort((a, b) => {
                            return a.name < b.name ? -1 : 1;
                        });

                        if (this.haendlerFuerGruppe.length === 0) {
                            this.label = 'keine Händler';
                            this.selectedHaendlerCtrl.disable();
                        } else {
                            this.label = 'Händler';
                        }
                    },
                    error: err => {
                        this.isLoading = false;
                        this.messageService.errorMessage('Fehler beim Laden der Händler', err);
                    },
                });
        }
    }
}
